<template>
  <v-container class="align-center justify-center" style="padding-bottom: 40px" fluid>
    <v-col style="padding: 15px 6px 6px;" cols="12">
      <v-card flat color="transparent">
        <v-card-text style="padding: 0;">
          <v-form>
            <v-text-field
              ref="formName"
              v-model="name"
              :placeholder="$t('Name')"
              name="name"
              type="text"
              outlined
              disabled
            />
            <v-text-field
              ref="formSurname"
              v-model="surname"
              :placeholder="$t('Surname')"
              name="surname"
              type="text"
              outlined
              disabled
            />
            <div>
              <v-text-field
                ref="formCif"
                v-model="cif"
                :placeholder="$t('NIE/NIF')"
                name="cif"
                type="text"
                outlined
                disabled
              />
            </div>
            <div>
              <v-text-field
                ref="formEmail"
                v-model="email"
                :placeholder="$t('E-mail')"
                name="email"
                type="text"
                outlined
                disabled
              />
            </div>
            <div>
              <v-text-field
                v-model="phone"
                outlined
                :placeholder="$t('phone number')"
                name="phonenumber"
                type="text"
                disabled
              />
            </div>
            <div>
              <v-checkbox v-model="cryptoPayments" label="Accept payments with cryptocurrency?" />
              <v-text-field v-if="cryptoPayments"
                            v-model="wallet"
                            outlined
                            :placeholder="$t('wallet')"
                            name="wallet"
                            type="text"

              />
            </div>
            <div>
              <v-checkbox v-model="acceptOpenBanking" label="Accept payments with open banking?" />
            </div>
            <div>
              <v-text-field v-if="acceptOpenBanking"
                            v-model="publicStripe"
                            outlined
                            :placeholder="$t('public stipe')"
                            name="public stipe"
                            type="text"

              />
              <v-text-field v-if="acceptOpenBanking"
                            v-model="privateStripe"
                            outlined
                            :placeholder="$t('private stipe')"
                            name="private stipe"
                            type="password"
              />
            </div>
            <div>
              <v-checkbox v-model="outsidePlatform" label="Accept payments outside platform?" />
            </div>
            <div>
              <v-checkbox v-model="acceptByppayes" label="Accept future byppayes from this user?" />
            </div>
          </v-form>
        </v-card-text>
        <div style="padding-top: 15px; text-align: center;">
          <v-btn class="btn-primary" dark style="cursor: pointer;" @click="addApprovedByppay()">
            {{ acceptByppayes ? $t('Approve this and futures byppayes') : $t('Approve this byppay') }}
          </v-btn>
        </div>
        <div style="padding-top: 15px; text-align: center;">
          <v-btn color="#FF6961" style="cursor: pointer;" @click="declineByppays()">
            {{ $t('Never accept byppayes from this user') }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import ApiRepository from "@/repositories/ApiRepository";
import Constants from "../../constants";

export default {
    name: "AcceptBypayes",
    data () {
        return {
            outsidePlatform: true,
            acceptOpenBanking: true,
            cryptoPayments: true,
            acceptByppayes: true,
            buttonText: this.$t('AcceptBypayes.Approve byppayes'),
            name: '',
            surname: '',
            phone: '',
            email: '',
            address: '',
            cif: '',
            publicStripe: '',
            privateStripe: '',
            wallet: '',
        };
    },
    mounted () {
        if (this.$route.query.userId) {
            if (this.$route.query.userId === this.$user._id) {
                this.$root.$emit('show-snackbar', {message: 'User id is the same as yours', color: 'error'});
                this.$router.push({name: 'home', replace: true});
            } else {
                ApiRepository.getUserById(this.$route.query.userId).then((user) => {
                    this.name = user.data.user.name;
                    this.surname = user.data.user.surname;
                    this.phone = user.data.user.phone;
                    this.email = user.data.user.email;
                    this.address = user.data.user.address;
                    this.cif = user.data.user.cif;
                });
            }
        } else {
            this.$root.$emit('show-snackbar', {message: 'User id not found', color: 'error'});
        }
        if (this.acceptByppayes) {
            this.wallet = this.$user.walletAddress;
        }
        if (this.acceptOpenBanking) {
            this.publicStripe = this.$user.stripePublickey;
            ApiRepository.getUserStripe().then((res) => {
                this.privateStripe = res.data.privateKey;
            })
                .catch((e) => {
                    this.privateStripe = '';
                });
        }
    },
    methods: {
        askLogin () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Login'),
                message: this.$t('In order to do this option you need to login, Do you want to login?'),
                oneButton: true,
                yes: () => {
                    this.$router.push({name: 'Login', replace: true});
                }
            });
        },
      
        addApprovedByppay () {
            if (this.$user) {
                const acceptedPaymentMethods = [];

                if (this.cryptoPayments) {
                    acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.CRYPTO);
                }
                if (this.outsidePlatform) {
                    acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM);
                }
                if (this.acceptOpenBanking) {
                    acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING);
                }
                this.$root.$emit('show-confirmation-modal', {
                    title: this.$t('Confirmation'),
                    message: this.$t('Do you want to accept byppayes?'),
                    yes: () => {
                        let checkOpenBank = true;
                        let checkWallet = true;
                        if (this.acceptByppayes && (this.wallet === '' || ! this.wallet)) {
                            checkWallet = false;
                        }
                        if (this.acceptOpenBanking && (this.publicStripe === '' || this.privateStripe === '' )) {
                            checkOpenBank = false;
                        }
                        if (checkWallet && checkOpenBank) {
                            if (this.acceptByppayes) {
                                ApiRepository.updateUserWallet(this.wallet).then((res) => {

                                }).catch((e) => {
                                    console.log(e);
                                    this.$root.$emit('show-snackbar', {message: this.$t(e.message), color: 'error'});
                                });
                            }
                            if (this.acceptOpenBanking) {
                                ApiRepository.updateUserStripe(this.publicStripe, this.privateStripe).then((res) => {

                                }).catch((e) => {
                                    console.log(e);
                                    this.$root.$emit('show-snackbar', {message: this.$t(e.message), color: 'error'});
                                });
                            }
                            ApiRepository.acceptByppayFromUser(this.$route.query.userId, acceptedPaymentMethods, this.acceptByppayes, this.$route.query.factoring).then(() => {
                                this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!')});
                                this.$router.push({name: 'home', replace: true});
                            });
                        } else {
                            let text = '';
                            if (this.acceptByppayes && ! checkWallet) {
                                text = 'Need wallet address \n';
                            }
                            if (this.acceptOpenBanking && ! checkOpenBank) {
                                text = 'Need stripe public and private key \n';
                            }
                            this.$root.$emit('show-snackbar', {message: text, color: 'error'});
                        }
                    },
                });
            } else {
                this.askLogin();
            }
        },

        declineByppays () {
            if (this.$user) {
                this.$root.$emit('show-confirmation-modal', {
                    title: this.$t('Confirmation'),
                    message: this.$t('Do you want to reject all byppayes?'),
                    yes: () => {
                        ApiRepository.declineByppays(this.$route.query.userId).then(() => {
                            this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!')});
                            this.$router.push({name: 'home', replace: true});
                        });
                    },
                });
            } else {
                this.askLogin();
            }
        },
    }
};
</script>

<style >
  .v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    height: 40px;
  }
  .right /deep/ input::placeholder {
    text-align: center;
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 4px !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #F4F4F4 inset !important;
    margin: 8px;
    padding: 0px;
  }
  html,body {
    margin:    0 auto;
    height: 100%;
    /*overscroll-behavior-y: none;*/
    /*overflow-y: hidden;*/
  }
  body {
    width: 100%;
    height: 100%;
    position: fixed;
    /*overflow: hidden;*/
  }
</style>
